import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './HeaderPage.css'

const PROFILE_ICON_URL = 'https://cdn-icons-png.flaticon.com/512/9815/9815472.png'

const HeaderPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isProfileOpen, setIsProfileOpen] = useState(false)

  const profileRef = useRef(null)

  // Check auth state on mount and whenever the route changes
  // (covers the redirect right after a successful login)
  useEffect(() => {
    const token =
      localStorage.getItem('token') || sessionStorage.getItem('token')
    setIsLoggedIn(!!token)
  }, [location])

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close the profile accordion when clicking outside it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const toggleProfileMenu = () => {
    setIsProfileOpen((prev) => !prev)
  }

  const goToProfile = () => {
    setIsProfileOpen(false)
    closeMenu()
    navigate('/myprofile')
  }

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('user')
    setIsLoggedIn(false)
    setIsProfileOpen(false)
    closeMenu()
    navigate('/login')
  }

  return (
    <header className={`upskld_head_pg_header ${isScrolled ? 'upskld_head_pg_scrolled' : ''}`}>
      <div className="upskld_head_pg_container">

        {/* Logo */}
        <div className="upskld_head_pg_logo_wrap">
          <a href="/" className="upskld_head_pg_logo_link">
            <img
              src="https://res.cloudinary.com/dk50cmtps/image/upload/v1786336638/592f1aee-a328-4135-bd3f-8a1e20477346_smm1fr.png"
              alt="upskld logo"
              className="upskld_head_pg_logo_img"
            />
          </a>
        </div>

        {/* Desktop Nav */}
        <nav className="upskld_head_pg_nav_desktop">
          <ul className="upskld_head_pg_nav_list">
            <li className="upskld_head_pg_nav_item">
              <a href="/about" className="upskld_head_pg_nav_link">About</a>
            </li>
           
            <li className="upskld_head_pg_nav_item">
              {isLoggedIn ? (
                <div className="upskld_head_pg_profile_wrap" ref={profileRef}>
                  <button
                    type="button"
                    className="upskld_head_pg_profile_btn"
                    onClick={toggleProfileMenu}
                    aria-label="Profile menu"
                  >
                    <img
                      src={PROFILE_ICON_URL}
                      alt="Profile"
                      className="upskld_head_pg_profile_icon"
                    />
                  </button>

                  <div
                    className={`upskld_head_pg_profile_accordion ${
                      isProfileOpen ? 'upskld_head_pg_profile_accordion_open' : ''
                    }`}
                  >
                    <button
                      type="button"
                      className="upskld_head_pg_accordion_item"
                      onClick={goToProfile}
                    >
                      Profile
                    </button>
                    <button
                      type="button"
                      className="upskld_head_pg_accordion_item upskld_head_pg_accordion_logout"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              ) : (
                <a href="/login" className="upskld_head_pg_nav_link upskld_head_pg_login_link">Login</a>
              )}
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Icon */}
        <button
          className={`upskld_head_pg_menu_icon ${isMenuOpen ? 'upskld_head_pg_menu_open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="upskld_head_pg_bar"></span>
          <span className="upskld_head_pg_bar"></span>
          <span className="upskld_head_pg_bar"></span>
        </button>
      </div>

      {/* Mobile Nav */}
      <nav className={`upskld_head_pg_nav_mobile ${isMenuOpen ? 'upskld_head_pg_nav_mobile_active' : ''}`}>
        <ul className="upskld_head_pg_nav_mobile_list">
          <li className="upskld_head_pg_nav_mobile_item">
            <a href="/about" className="upskld_head_pg_nav_mobile_link" onClick={closeMenu}>About</a>
          </li>
        

          {isLoggedIn ? (
            <>
              <li className="upskld_head_pg_nav_mobile_item">
                <button
                  type="button"
                  className="upskld_head_pg_nav_mobile_link upskld_head_pg_mobile_action_btn"
                  onClick={goToProfile}
                >
                  Profile
                </button>
              </li>
              <li className="upskld_head_pg_nav_mobile_item">
                <button
                  type="button"
                  className="upskld_head_pg_nav_mobile_link upskld_head_pg_mobile_action_btn"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </>
          ) : (
            <li className="upskld_head_pg_nav_mobile_item">
              <a href="/login" className="upskld_head_pg_nav_mobile_link" onClick={closeMenu}>Login</a>
            </li>
          )}
        </ul>
      </nav>
    </header>
  )
}

export default HeaderPage